// removed by extract-text-webpack-plugin
module.exports = {"MenuBox":"Info__MenuBox__2qvLe","ToTopLink":"Info__ToTopLink__30UC0","SectionTitle":"Info__SectionTitle__3G4rS","InfoTitle":"Info__InfoTitle__1HGu1","InfoWrapper":"Info__InfoWrapper__13fmm","SubNote":"Info__SubNote__2Gapu","Note":"Info__Note__1ST1p"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Info/Info.css
// module id = 370
// module chunks = 0